import templateUrl from './home.html';

export const homeComponent = {
	bindings: {
		features: '<'
	},
	templateUrl,
	controller: class HomeComponent {

		constructor($state, HomeService, AuthService) {
			'ngInject';
			this.$state = $state;
			this.HomeService = HomeService;
			this.authService = AuthService;
		}
		$onInit() {
			this.user = this.authService.getUser();
			// console.log("this.user.role",this.user.role)
			// this.isCommandCounselor =
			// this.user.role && this.user.role === "commandCareerCounselor";
		}
		onClick(routeName) {
			if (this.user.role && this.user.role === "commandCareerCounselor") {
				if (routeName === "commandCounsellorGroupsroute") {
					routeName = "commandCounsellorGroup";
				}
			}
			this.$state.go(routeName);
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/home/home.component.js